import { render, staticRenderFns } from "./ex-list.vue?vue&type=template&id=e0677f10&scoped=true&"
import script from "./ex-list.vue?vue&type=script&lang=js&"
export * from "./ex-list.vue?vue&type=script&lang=js&"
import style0 from "./ex-list.vue?vue&type=style&index=0&id=e0677f10&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0677f10",
  null
  
)

export default component.exports